// Where to go after signing in. Only paths inside the dashboard are accepted, so a crafted link can't send someone
// to another site.

export const safeReturnTo = (value: string | null | undefined): string =>
  value && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\') ? value : '/'

/** The current page as a returnTo value. */
export const currentPath = (): string => `${window.location.pathname}${window.location.search}`
